import React, { useState, useRef } from 'react';

const HinglishTextarea = ({ value, onChange, onKeyDown, ...props }) => {
  const [isHinglishMode, setIsHinglishMode] = useState(true);
  const textareaRef = useRef(null);

  const transliterateText = async (text) => {
    try {
      // Using Google Input Tools API for transliteration
      const response = await fetch('https://inputtools.google.com/request?text=' + encodeURIComponent(text) + '&itc=hi-t-i0-und&num=1&cp=0&cs=1&ie=utf-8&oe=utf-8&app=demopage');
      const data = await response.json();
      
      if (data[1] && data[1][0] && data[1][0][1]) {
        return data[1][0][1][0];
      }
      return text;
    } catch (error) {
      console.error('Transliteration failed:', error);
      return text;
    }
  };

  const handleKeyPress = async (e) => {
    if (isHinglishMode && e.key === ' ') {
      e.preventDefault();
      
      const textarea = textareaRef.current;
      const cursorPos = textarea.selectionStart;
      const textBeforeCursor = value.substring(0, cursorPos);
      const textAfterCursor = value.substring(cursorPos);
      
      // Find the last word
      const words = textBeforeCursor.split(' ');
      const lastWord = words[words.length - 1];
      
      if (lastWord) {
        const transliterated = await transliterateText(lastWord);
        const newTextBefore = words.slice(0, -1).join(' ') + (words.length > 1 ? ' ' : '') + transliterated + ' ';
        const newValue = newTextBefore + textAfterCursor;
        
        onChange({ target: { value: newValue } });
        
        // Set cursor position after the transliterated word
        setTimeout(() => {
          textarea.setSelectionRange(newTextBefore.length, newTextBefore.length);
        }, 0);
      } else {
        onChange({ target: { value: value + ' ' } });
      }
    }
    
    if (onKeyDown) onKeyDown(e);
  };

  return (
    <div className="hinglish-textarea">
      <div className="hinglish-controls">
        <button
          type="button"
          className={`hinglish-toggle ${isHinglishMode ? 'active' : ''}`}
          onClick={() => setIsHinglishMode(!isHinglishMode)}
        >
          {isHinglishMode ? 'हिं' : 'EN'}
        </button>
        <span className="hinglish-hint">
          {isHinglishMode ? 'Type in English, press Space to convert to Hindi' : 'English mode'}
        </span>
      </div>
      <textarea
        ref={textareaRef}
        value={value}
        onChange={onChange}
        onKeyDown={handleKeyPress}
        {...props}
      />
    </div>
  );
};

export default HinglishTextarea;